"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDebounce = useDebounce;
exports.useIsCurrentPath = void 0;
exports.useScrollIntoView = useScrollIntoView;
exports.useShortcut = useShortcut;
var _isKeyCombo = _interopRequireDefault(require("is-key-combo"));
var _react = _interopRequireDefault(require("react"));
var _debounce = _interopRequireDefault(require("debounce"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _reactRouterDom = require("react-router-dom");
var useIsCurrentPath = exports.useIsCurrentPath = function useIsCurrentPath() {
  var location = (0, _reactRouterDom.useLocation)();
  var getPortalPath = (0, _exchangeReactHooks.useGetPortalPath)();
  return function (path) {
    var _match$isExact;
    if (path === null || path === undefined) {
      return false;
    }
    var resultPath = getPortalPath(path);
    var match = (0, _reactRouterDom.matchPath)(location.pathname, resultPath);

    // special case for home page, should match '/' and '/pages/home'
    if (path === '/pages/home') {
      var _ref;
      var homePath = getPortalPath('/');
      var homeMatch = (0, _reactRouterDom.matchPath)(location.pathname, homePath);
      return (_ref = (match === null || match === void 0 ? void 0 : match.isExact) || (homeMatch === null || homeMatch === void 0 ? void 0 : homeMatch.isExact)) !== null && _ref !== void 0 ? _ref : false;
    }
    return (_match$isExact = match === null || match === void 0 ? void 0 : match.isExact) !== null && _match$isExact !== void 0 ? _match$isExact : false;
  };
};
function useShortcut(combo, callbackOrElement, callback) {
  _react.default.useEffect(function () {
    var handleKeyDown = function handleKeyDown(event) {
      if ((0, _isKeyCombo.default)(event, combo)) {
        if (typeof callbackOrElement === 'function') {
          callbackOrElement(event);
        } else {
          callback(event);
        }
      }
    };
    var targetElement = typeof callbackOrElement === 'function' ? global : callbackOrElement;
    targetElement === null || targetElement === void 0 || targetElement.addEventListener('keydown', handleKeyDown);
    return function () {
      targetElement === null || targetElement === void 0 || targetElement.removeEventListener('keydown', handleKeyDown);
    };
  }, [combo, callbackOrElement, callback]);
}
function useDebounce(callback, delay) {
  var ref = _react.default.useRef();
  _react.default.useEffect(function () {
    ref.current = callback;
  }, [callback]);
  var debouncedCallback = _react.default.useMemo(function () {
    var func = function func() {
      if (ref.current) ref.current.apply(ref, arguments);
    };
    return (0, _debounce.default)(func, delay);
  }, [delay]);
  return debouncedCallback;
}

/**
 * Will scroll the view to show the element when condition is met
 */
function useScrollIntoView(ref, condition) {
  _react.default.useEffect(function () {
    if (condition) {
      var _ref$current;
      // this fn is not implemented everywhere yet: https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoViewIfNeeded
      if ((_ref$current = ref.current) !== null && _ref$current !== void 0 && _ref$current.scrollIntoViewIfNeeded) {
        ref.current.scrollIntoViewIfNeeded();
      } else if (ref.current) {
        var _ref$current$scrollIn, _ref$current2;
        (_ref$current$scrollIn = (_ref$current2 = ref.current).scrollIntoView) === null || _ref$current$scrollIn === void 0 || _ref$current$scrollIn.call(_ref$current2);
      }
    }
  }, [ref, condition]);
}
//# sourceMappingURL=hooks.js.map